const stories = [
  { name: 'The competitor', role: 'Ranked grinder', quote: 'Opens a Checkers room between ranked queues, sends the code to a rival and keeps score on the leaderboard.' },
  { name: 'The streamer’s squad', role: 'Watch-party host', quote: 'Drops a Twitch link into a room so the whole squad watches the broadcast together while trash-talking in chat.' },
  { name: 'The team captain', role: 'Esports coordinator', quote: 'Uses game-specific rooms and Favourites to gather the same five players every practice night.' },
  { name: 'The newcomer', role: 'Casual player', quote: 'Taps “Find Players” on a favourite game, accepts an invite and lands in a room with someone new to play with.' },
  { name: 'The commuter', role: 'On-the-go chatter', quote: 'Uses voice dictation to send quick callouts without typing, then reviews the text before sending.' },
  { name: 'The community manager', role: 'Admin', quote: 'Imports new titles from RAWG.io and FreeToGame so their community always has a room for the latest release.' },
];

const initials = (s) => s.replace(/^The\s+/i, '').split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

export const Testimonials = () => (
  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="testimonials-grid">
    {stories.map((s) => (
      <div key={s.name} className="p-6 bg-white border border-[#E4E4E7] hover:border-[#0047FF] transition-colors group">
        <p className="text-[#71717A] mb-6 leading-relaxed">{s.quote}</p>
        <div className="flex items-center gap-3">
          <span className="w-12 h-12 bg-[#0047FF]/10 text-[#0047FF] font-mono font-bold flex items-center justify-center">{initials(s.name)}</span>
          <div>
            <p className="font-medium text-[#09090B] group-hover:text-[#0047FF] transition-colors">{s.name}</p>
            <p className="text-sm text-[#71717A]">{s.role}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
);
